export const SAVED_TIME_SUFFIX = 'min';
